export default __webpack_public_path__ + "static/media/Layer8.ebd36e73.png";